import React, { useState, useEffect } from 'react';
import classes from "./package.module.css";
import InputField from "../../../containers/inputField/inputField";
import WhiteArrow from "../../../../assets/images/double-arrow.png";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Package = (props) => {              
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [selectedPackage, setSelectedPackage] = useState(props.selectedPlan || {});
    const [interval, setInterval] = useState([]);
    const [service, setService] = useState([]);
    const [intervalControl, setIntervalControl] = useState({
        list: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: "Select interval",
                options: []
            },
            value: "",
            validation: {
                required: true
            },
            label: "Interval",
            valid: false,
            touched: false
        }
    });
    useEffect(() => {
        fetchInterval();
    }, [selectedPackage?.id]);
    const fetchInterval = async () => {
        try {
            const res = await sixYardAxios.get("camps/packages/" + selectedPackage?.id + "/intervals");
            setInterval(res.data.data);
            const intervalOptions = res.data.data
                .map(Option => ({
                    value: Option.id,
                    displayValue: Option.duration,
                }))
            if (intervalOptions.length > 0) {
                updateControlOptions("list", intervalOptions, intervalOptions[0].value);
            } else {
                updateControlOptions("list", [], "");
            }
        } catch (error) { }
    };
    const updateControlOptions = (controlName, options, defaultValue = "") => {
        setIntervalControl((prevControls) => ({
            ...prevControls,
            [controlName]: {
                ...prevControls[controlName],
                elementConfig: {
                    ...prevControls[controlName].elementConfig,
                    options: options,
                },
                value: defaultValue,
                valid: !!defaultValue,
                touched: !!defaultValue
            },
        }));
    };
    const handleCheckboxChange = (id) => {
        setService((prevService) => {
            const exists = prevService.some((service) => service.service_id === id);
            if (exists) {
                return prevService.filter((service) => service.service_id !== id);
            } else {
                return [...prevService, { service_id: id }];
            }
        });
    };

    const inputChangedHandler = (event, options) => {
        const updatedControls = {
            ...intervalControl,
            list: {
                ...intervalControl.list,
                value: event.target.value,
                touched: true
            }
        };
        setIntervalControl(updatedControls);
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const interval_id = Number(intervalControl.list.value);
            const formData = {
                camp_id: props.camp === "Football" ? 1 : props.camp === "Summer" ? 2 : props.camp === "Winter" && 3,
                package_id: selectedPackage.id,
                interval_id: interval_id,
                start_date: interval[interval_id - 1]["start_date"],
                end_date: interval[interval_id - 1]["end_date"],
                participants: [{
                    name: name
                }],
                extra_services: service
            }
            const response = await sixYardAxios.post('/camps/register', formData);
            if (response.data.data) {
                props.setBookingData(response.data.data);
                props.setRegistrationId(response.data.data.registration_id);
                localStorage.setItem("campRegistrationFormPackage", JSON.stringify(formData))
                props.setCurrentStep(props.currentStep + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
                <div className={classes.SectionTitle}>Child's Details</div>
                <div className={classes.Field}>
                    <InputField
                        elementType='input'
                        elementConfig={{
                            type: "text",
                            placeholder: 'Enter name',
                        }}
                        shouldValidate={{ required: true }}
                        value={name}
                        label="Kid's Name"
                        changed={event => setName(event.target.value)}
                    />
                </div>
                <div className={classes.SectionTitle}>Session</div>
                <div className={classes.Field}>
                    <label className={classes.Label}>Package <span className={classes.Required}>*</span></label>
                    <div className={classes.RadioGroup}>{props.packages?.map(plan =>
                        <label key={plan.id} className={selectedPackage.id === plan.id ? classes.LabelChecked : ''}>
                            <input
                                type="radio"
                                name="interval"
                                id={plan.id}
                                value={plan.id}
                                checked={selectedPackage.id === plan.id}
                                onChange={() => setSelectedPackage(plan)}
                            />
                            {plan.name} {plan.discount_percentage > 0 && <span>{plan.discount_percentage}%</span>}
                        </label>)}
                    </div>
                </div>
                <div className={classes.Field}>
                    <InputField
                        elementType={intervalControl.list.elementType}
                        elementConfig={intervalControl.list.elementConfig}
                        value={intervalControl.list.value}
                        invalid={!intervalControl.list.valid}
                        shouldValidate={intervalControl.list.validation}
                        touched={intervalControl.list.touched}
                        label={intervalControl.list.label}
                        changed={event => inputChangedHandler(event)}
                    />
                </div>
                <div className={classes.SectionTitle}>Extra Services</div>
                <div className={classes.Field}>
                    {props.extraServices?.map(item =>
                        <div className={classes.CheckBox} key={item.id}>
                            <input type="checkbox"
                                onChange={() => handleCheckboxChange(item.id)}
                                checked={service.some((serviceItem) => serviceItem.service_id === item.id)} />
                            <label className={classes.Label}>
                                {item.name}
                            </label>
                            <span>{Math.trunc(item.price)}JD / {item.price_type}</span>
                        </div>
                    )}</div>
                <button type='submit'
                    className={[classes.Next].join(" ")}
                >
                    NEXT <img
                        src={WhiteArrow}
                        alt=""
                        className={classes.SubmitIcon}
                    />
                </button>
            </form>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
        </>
    )
}
export default Package;